import { ComparePage } from "./ComparePage";
import { useLang } from "../lib/i18n";
import { compareKrispCopy } from "../lib/translations/pages/compare-krisp";

export function CompareKrisp() {
  const lang = useLang();
  return <ComparePage copy={compareKrispCopy[lang]} path="/compare/krisp-vs-minuta" />;
}
